import { QueryClient } from "@tanstack/react-query";
import { isServerUnavailable } from "./api-client.js";

/**
 * A proxy error page while the API restarts (KG-16) usually clears within seconds, so a query that
 * hit one retries a few more times with backoff before giving up; anything else retries once.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  return failureCount < (isServerUnavailable(error) ? 3 : 1);
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
    },
  },
});
